module.exports = __webpack_public_path__ + "img/SES_194418602.4764d7c8.jpg";